/* eslint-disable default-case */
// @flow
import '../banners.less';
import './index.less';

import { Col, Modal, Row } from 'antd';
import React, { useState } from 'react';
import Fade from 'react-reveal/Fade';

import DotArrowDown from '../../../../static/svg/dot-arrow-down.svg';
import PlayIcon from '../../../../static/svg/grey-play.svg';
import SGHomepagePlaceholder from '../../../images/banners/homepage-img-placeholder.png';
import SGHomepage2 from '../../../images/banners/theworkout-2.jpg';
import SGHomepage3 from '../../../images/banners/theworkout-3.jpg';
import SGHomepage1 from '../../../images/banners/theworkout.jpg';
import Breakpoint from '../../../utils/breakpoint';
import whyHiit from '../../../videos/134_1707210920.mp4';
import Title from '../../BannerShared/Title';
import AppButton from '../../Button';
import ImageRotator from '../../ImageRotator';
import Video from '../../Video';

const HeroTheWorkout = () => {
  const [showVideo, setShowVideo] = useState(false);

  const handleVideo = () => {
    setShowVideo(true);
  };

  return (
    <div className="banner banner-workout-hero">
      <div className="container">
        <Fade>
          {/* DESKTOP ONLY > IPAD */}
          <Breakpoint min="lg">
            <Row align="middle">
              <Col xs={24} sm={12} md={12} lg={12}>
                <section>
                  <div className="banner-workout-hero-content">
                    <Title title="The Workout" isTagline />
                    <Title
                      title="快速<br/>高效<br/><span>令人着迷</span>"
                      description="我们的 30 分钟课程是力量训练和有氧运动的完美结合，能锻炼肌肉、燃烧脂肪，让您流连忘返。"
                      titleClassName="banner-title"
                      paragraphStyle={{
                        maxWidth: '550px',
                      }}
                    />
                    <div>
                      <AppButton type="button" transform="lowercase" color="outline" onClick={() => handleVideo()}>
                        <img src={PlayIcon} alt="Play" style={{ marginRight: '10px' }} />
                        <span>Watch Video</span>
                      </AppButton>
                    </div>
                  </div>
                </section>
              </Col>
              <Col xs={0} sm={12} md={11} lg={12}>
                <div className="box-image-container">
                  <div className="grey-box">&nbsp;</div>

                  <img src={SGHomepagePlaceholder} alt="Placeholder" />
                  <ImageRotator images={[SGHomepage1, SGHomepage2, SGHomepage3]} />
                </div>
              </Col>
            </Row>
          </Breakpoint>

          <Breakpoint max="lg">
            <Row>
              <Col xs={24} sm={24} md={24} lg={12}>
                <section>
                  <Breakpoint max="lg">
                    <div className="box-image-container">
                      <div className="grey-box">&nbsp;</div>
                      <img src={SGHomepagePlaceholder} alt="Placeholder" />
                      <ImageRotator images={[SGHomepage1, SGHomepage2, SGHomepage3]} />
                    </div>
                    <>
                      <div className="banner-workout-hero-content">
                        <Title title="The Workout" isTagline />
                        <Title
                          title="快速<br/>高效<br/><span>令人着迷</span>"
                          titleClassName="banner-title"
                          paragraphStyle={{
                            maxWidth: '595px',
                          }}
                        />
                      </div>
                      <div className="banner-workout-hero-content-paragraph">
                        <p>我们的 30 分钟课程是力量训练和有氧运动的完美结合，能锻炼肌肉、燃烧脂肪，让您流连忘返。</p>
                      </div>
                    </>
                  </Breakpoint>
                  <Breakpoint min="lg">
                    <div className="banner-workout-hero-content">
                      <Title title="The Workout" isTagline />
                      <Title
                        title="快速<br/>高效<br/><span>令人着迷</span>"
                        description="我们的 30 分钟课程是力量训练和有氧运动的完美结合，能锻炼肌肉、燃烧脂肪，让您流连忘返。"
                        titleClassName="banner-title"
                        paragraphStyle={{
                          maxWidth: '550px',
                        }}
                      />
                    </div>
                  </Breakpoint>
                </section>
              </Col>
            </Row>
          </Breakpoint>
          <Row justify="center">
            <Col span={24} style={{ textAlign: 'center' }}>
              <img src={DotArrowDown} className="workout-down-arrow" alt="" />
            </Col>
          </Row>
        </Fade>
      </div>
      {showVideo ? (
        <Modal
          maskStyle={{
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
          }}
          zIndex={9999999}
          maskClosable
          visible
          onCancel={() => setShowVideo(false)}
          centered
          wrapClassName="modal-video"
          footer={null}
        >
          <Video src={whyHiit} />
        </Modal>
      ) : null}
    </div>
  );
};

export default HeroTheWorkout;
